import { CompanyCreatePage } from "@/features/company/pages/CompanyCreate";
import React from "react";

const CompanyCreate = () => {
  return <CompanyCreatePage />;
};

export default CompanyCreate;
